document.addEventListener('DOMContentLoaded', function() {
  const headings = document.querySelectorAll('.footer-block__heading');
  
  headings.forEach(function(heading) {
    heading.addEventListener('click', function() {
      const nextElement = heading.nextElementSibling;
      if (nextElement) {
        nextElement.style.display = (nextElement.style.display === 'none' || nextElement.style.display === '') ? 'block' : 'none';
      }
    });
  });

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();
    
    const header = document.querySelector('header');
    console.log(header,'header')
    const headerHeight = header.offsetHeight;

    const targetElement = document.querySelector(this.getAttribute('href'));

    const targetPosition = targetElement.offsetTop - headerHeight;

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  });
});
  
// --------------------Faq Page Tab JS

const faqtitle = document.querySelectorAll('.faq-tab-button li');
  const faqcontent = document.querySelectorAll('.accordion-block-wrap');

  faqtitle.forEach((title) => {
    title.addEventListener("click", function (event) {
      const dataValue = this.getAttribute("data-faq-block");
      
      faqtitle.forEach((item) => {
        item.classList.remove("active");
      });
      
      this.classList.add("active");

      faqcontent.forEach((content) => {
        content.style.display = "none";
        
        const detailsElement = content.querySelector('details');
        if (detailsElement) {
          detailsElement.removeAttribute('open'); 
        }
      });

      var contentToShow = document.querySelector(`.accordion-block-wrap[data-faq-block="${dataValue}"]`);
      const detailsElement = contentToShow.querySelectorAll('.faq_content');
       detailsElement.forEach((contentfaq) => {
            if (contentfaq.classList.contains('active')) {
              contentfaq.classList.remove('active');
            } else {
              var firtsfaq = contentToShow.querySelector('.faq_content')
              firtsfaq.classList.add('active');
            }
        });
      if (contentToShow) {
        contentToShow.style.display = "block";
        
      }
    });
  });


// --------------------Faq Page JS
const faqTitles = document.querySelectorAll('.faq_title');

faqTitles.forEach(faq => {
  faq.addEventListener('click', function() {
    const faqItem = faq.parentNode; 
    const faqContentt = faqItem; 
    document.querySelectorAll('.faq_content.active').forEach(item => {
      if (item !== faqContentt) {
        item.classList.remove('active');
      }
    });

    faqContentt.classList.toggle('active');
  });
});
  
});




document.addEventListener("DOMContentLoaded", function() {
  var passwordInput = document.querySelector(".pass-view");
  var passwordViewIcon = document.querySelector(".password-view");
  var showPasswordIcon = document.querySelector(".showpassword_icon");

  if (passwordInput && passwordViewIcon) {
    // Add click event listener to the password view icon
    passwordViewIcon.addEventListener("click", function() {
      togglePasswordVisibility();
    });

    // Add click event listener to the .showpassword_icon parent element
    showPasswordIcon.addEventListener("click", function(event) {
      // Check if the click occurred on the pseudo-element
      if (event.target.matches('.showpassword_icon::after')) {
        togglePasswordVisibility();
      }
    });
  }

  function togglePasswordVisibility() {
    showPasswordIcon.classList.toggle('active');

    // Toggle the type attribute of the password input field
    if (passwordInput.type === "password") {
      passwordInput.type = "text";
    } else {
      passwordInput.type = "password";
    }
  }
});


// -------------------form section JS start------

const TabClick = document.querySelectorAll('.flexbox li');
if (TabClick) {
  
// TabClick.forEach(TabsClick => {
//     TabsClick.addEventListener('click', function (event) {
//         this.classList.add("active");

//         const dataTitle = this.getAttribute("data-title");
//         const allContent = document.querySelectorAll('.formtab-details');
        
//         // Hide all content first
//         allContent.forEach(content => {
//             content.style.display = "none";
//         });

//         // Show the clicked tab's content
//         const datacontent = document.querySelector(`.formtab-details[data-content="${dataTitle}"]`);
//         console.log(datacontent, "datacontent");

//         if (datacontent) {
//             datacontent.style.display = "block";
//         }
//     });
// });
}

// ------------ amazonen contact form submit button disabled remove 
$(document).ready(function() {
  
  function checkSubmitButton(formTab) {
 

  if($(formTab).find('.field input[required]').length > 0){
   var allFieldsFilled = $(formTab).find('.field input[required]').length > 0 && $(formTab).find('.field input[required]').toArray().every(input => $(input).val().trim().length > 0);
  }else{
    var allFieldsFilled = true
  }


  if($(formTab).find('.field .select_field[required]').length > 0){
    var isSelected = $(formTab).find('.field .select_field[required] .area_list:selected').length > 0;
  }else{
    var isSelected = true
  }
    
 if($(formTab).find('.field .aras_dropdown_Field[required]').length > 0){
    var isarasSelected = $(formTab).find('.field .aras_dropdown_Field[required] .area_list:selected').length > 0;
  }else{
    var isarasSelected = true
  }
 
    
    var submitButton = $(formTab).find('.submit-nextback-btn span.button');
     if (allFieldsFilled && isSelected && isarasSelected) {
      submitButton.removeAttr('disabled'); 
    } else {
     submitButton.attr('disabled', true);
    }
  }

  $('.formtab-details-wrap .field input, .formtab-details-wrap .field .select_field').on('input change', function() {
    var currentFormTab = $(this).closest('.formtab-details'); 
    checkSubmitButton(currentFormTab); 
  });
  // checkSubmitButton();
  $('.formtab-details').each(function() {
    checkSubmitButton(this);
  });

// -------------dropdown click img change  -------


  var dropdown = document.querySelector(".field .aras_dropdown_Field[required]");
if (dropdown) {
    dropdown.addEventListener("change", function(event) {
        var currentFormTab = this.closest('.formtab-details'); 
        checkSubmitButton(currentFormTab); 
        var selectedOption = dropdown.options[dropdown.selectedIndex];
        var imgData = selectedOption.getAttribute('data-img');
        const valueGet = selectedOption.value;
       

        if (imgData) {
            const imgadd = document.querySelector(".section-wrap_form");
            
            imgadd.classList.forEach(function(className) {
                if (className.startsWith('form-name-')) {
                    imgadd.classList.remove(className);
                }
            });

            imgadd.classList.add('form-name-' + valueGet);

            imgadd.style.setProperty('--sectionbg_image', 'url(' + imgData + ')');
        } else {
            console.log("Image not found");
        }

          const fieldshow = document.querySelector(".field.welches_tier");
         if (fieldshow) {
         if (valueGet == 'sonstige'){
          fieldshow.style.display = 'block';
         } else {
           fieldshow.style.display = 'none';
         }
        }
    });
} 


  

 $('.submit-nextback-btn span.button').click(function() {
        var currentForm = $(this).closest('.formtab-details'); 
   console.log(currentForm,"currentFormcurrentFormcurrentForm")
        var nextForm = currentForm.next('.formtab-details'); 
        currentForm.hide();
        nextForm.show();
        var datacontentSubmit = nextForm.attr('data-content');
            TabClick.forEach(removeClass => {
        removeClass.classList.remove("current");
      });
        var selectedItem = $('.flexbox li[data-title="'+datacontentSubmit+'"]').addClass('active current');
  
    });

    $('.backbutton-text').click(function() {
        var currentForm = $(this).closest('.formtab-details'); 
      console.log(currentForm,"currentForm")
        var prevForm = currentForm.prev('.formtab-details'); 
      console.log(prevForm,"prevForm")
        currentForm.hide();
        prevForm.show();
        var datacontentSubmit = currentForm.attr('data-content');
      console.log(datacontentSubmit,"datacontentSubmit");
   
        var selectedItem = $('.flexbox li[data-title="'+datacontentSubmit+'"]').removeClass('active');
    });
  
});

// ------------------------- amazonen contact form validateEmail
function validateEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
if(document.getElementById("submit-btn")){
document.getElementById("submit-btn").addEventListener("click", function(event) {
  const email = document.getElementById("email").value;
  const errorSpan = document.getElementById("email-error");

  if (!validateEmail(email)) {
    event.preventDefault();  
    errorSpan.style.display = "inline"; 
  } else {
    errorSpan.style.display = "none"; 
  }
});
}
// -------------------form section JS End------

// ------------------contact form submit to check if checkbox checked or not JS
// const contactButton = document.querySelector('.contact__button');
// const errorMess = document.querySelector(".checkbox_error_mess");

// if (contactButton) {
//   contactButton.addEventListener("click", function(event) {
//     // Find the checkbox
//     const checkbox = document.querySelector('.field_checkbox input[type="checkbox"]'); // Adjust the selector to match your HTML

//     // Check if the checkbox is checked
//     if (!checkbox.checked) {
//       // If checkbox is not checked, display the error message
//       errorMess.style.display = "block";
//       console.log("Error: checkbox not checked");
//     } else {
//       // If checkbox is checked, hide the error message
//       errorMess.style.display = "none";
//       console.log("Checkbox is checked, proceed");
//       // If needed, you can trigger form submission or any other actions here
//     }
//   });
// }

// ------------------ checkout disabled remove

var checker = document.getElementById('cardcheckout_button');
var sendbtn = document.getElementById('checkout');
if (checker) {
  
checker.onchange = function() {
  sendbtn.disabled = !this.checked;
};
}
function TabName(evt, tabname) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("producttab-info");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].classList.remove("activetab");
  }
  tablinks = document.getElementsByClassName("tabbutton");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(tabname).classList.add("activetab");
  evt.currentTarget.className += " active";
}




// ----------------properties Pass---------


const Colorproperties = document.querySelectorAll('.geflecht_auswahlen input');
console.log(Colorproperties, "Colorproperties");

if (Colorproperties.length > 0) { 

  function ColorInputChange() {
    Colorproperties.forEach(property => {
      if (property.checked) {
        const PassValue = document.querySelector('.geflecht_title');
        if (PassValue) {
          PassValue.value = property.value.trim();
        }
      }
    });
  }

  Colorproperties.forEach(property => {
    property.addEventListener("change", ColorInputChange);
  });

  ColorInputChange();
}

// const propertiesOther = document.querySelectorAll('.rahmen_auswahlen input');
// function OtherInputChange() {
//   propertiesOther.forEach(property => {
//     if (property.checked) {
//       const PassValue = document.querySelector('.rahmen_title');
//       PassValue.value = property.value;
//     }
//       property.addEventListener("change", () => {
//       OtherInputChange();
//       });
//   });
// }

window.addEventListener('load', () => {
  ColorInputChange();
});

// --------------------- Home page form open
const popupBtn = document.querySelectorAll('.popup-buttonclick');
const MainACtive = document.querySelector('.formpoup-block');
const overlayActive =  document.querySelector('.popup-overlay');
const bodyActive =  document.querySelector('body');
popupBtn.forEach(popupBtns => {
    popupBtns.addEventListener('click', function (event) {
        event.preventDefault()
        console.log('this',this);
      const bodyActive =  document.querySelector('body');
      MainACtive.classList.add("active");
      overlayActive.classList.add("active");
      bodyActive.classList.add("open-popup");
    });   
  

});
function removeActive() {
    MainACtive.classList.remove("active");
      overlayActive.classList.remove("active");
      bodyActive.classList.remove("open-popup");
}
overlayActive.addEventListener('click', function (event) {
        console.log('this',this);
      
    removeActive();
    });    


 document.querySelector('.closeicon').addEventListener('click', function (event) {
  removeActive();
  });

// ------------- variant vise video open
const videoClick = document.querySelector('.open-video');
const videoAdd = document.querySelector('.variant-video video');
const videoOpen = document.querySelector('.video-metafield-block');

if (videoClick) {
   videoClick.addEventListener('click', function (event) {
     console.log(videoClick,"videoClick");
     videoOpen.classList.add("video-open-popup");
     videoAdd.load();
    });   
  
}
const closeiconvideo = document.querySelector('.closeicon-video');

if (closeiconvideo) {
   closeiconvideo.addEventListener('click', function (event) {
     
     videoOpen.classList.remove("video-open-popup");
    });   
}
  

// ------------- Dropdown Click Div 
// const dropdownClickDiv = document.querySelectorAll('.dropdown_value_wrp .tooltip-box-wrap svg');
// if (dropdownClickDiv) {


// dropdownClickDiv.forEach(dropdownClickDivs => {
//   dropdownClickDivs.addEventListener('click', function() {
//     const dropdownItem = dropdownClickDivs.parentNode; 
//     const dropdownContentt = dropdownItem; 
//     document.querySelectorAll('.dropdown_value_wrp.active_text').forEach(item => {
//       if (item !== dropdownContentt) {
//         item.classList.remove('active_text');
//       }
//     });

//     dropdownContentt.classList.toggle('active_text');
//   });
// }); 
// }

// ------------------- product page Sondermaß button click
// const popupbtn = document.querySelectorAll('.popup_button');
// if (popupbtn) {
// popupbtn.forEach(popupbtns => {
//   popupbtns.addEventListener('click', function() {
//       const addClassP = document.querySelector('.prodcut-form-box');
//       addClassP.classList.add("open-popup-form");
//   });
// }); 
// }
// const popupbtnclose = document.querySelectorAll('.icon-close_productpage');
// if (popupbtnclose) {
// popupbtnclose.forEach(popupbtncloses => {
//   popupbtncloses.addEventListener('click', function() {
//       const addClassP = document.querySelector('.prodcut-form-box');
//       addClassP.classList.remove("open-popup-form");
//   });
// }); 
// }

// =====================


const multiselectB = document.querySelectorAll('.multi_select_button');

multiselectB.forEach(button => {
  button.addEventListener('click', function(event) {
    const faqItem = button.closest('.multi_select_box'); 

    document.querySelectorAll('.multi_select_box.active').forEach(item => {
      if (item !== faqItem) {
        item.classList.remove('active-select');
      }
    });

    faqItem.classList.toggle('active-select');
   
  });
});

document.addEventListener('click', function(event) {
  document.querySelectorAll('.multi_select_box.active-select').forEach(item => {
    if (!item.contains(event.target)) { 
      item.classList.remove('active-select');
    }
  });
});

// ------------------  multi_select value add 

document.querySelectorAll('.multi_select input[type="checkbox"]').forEach(function(checkbox) {
  checkbox.addEventListener('change', function() {
    updateButtonText();
  });
});

function updateButtonText() {
  const selectedValues = [];
  document.querySelectorAll('.multi_select input[type="checkbox"]:checked').forEach(function(checkbox) {
    selectedValues.push(checkbox.value);
  });
  
  const button = document.querySelector('.multi_select_button');
  if (selectedValues.length > 0) {
    button.textContent = 'Untergrund: ' + selectedValues.join(', ');
  } else {
    button.textContent = 'Untergrund'; 
  }
}


document.addEventListener('DOMContentLoaded', function () {
  const dotclick = document.querySelectorAll('.points');

  function handleClick(event) {
    const dotclicks = event.target.closest('.points');
    const dotItem = dotclicks.parentNode;
    const dotContentt = dotItem;

    document.querySelectorAll('.focalpoint.focalpoint-active').forEach(item => {
      if (item !== dotContentt) {
        item.classList.remove('focalpoint-active');
      }
    });

    dotContentt.classList.toggle('focalpoint-active');
  }

  function updateEventListeners() {
    if (window.innerWidth <= 1199) {
      dotclick.forEach(dotclicks => {
        dotclicks.addEventListener('click', handleClick);
      });
    } else {
      dotclick.forEach(dotclicks => {
        dotclicks.removeEventListener('click', handleClick);
      });
    }
  }

  updateEventListeners();

  window.addEventListener('resize', updateEventListeners);

  // Click outside to remove the class
  document.addEventListener('click', function(event) {
    let isClickInside = false;

    // Check if the click is inside any .points element
    dotclick.forEach(itemD => {
      if (itemD.contains(event.target)) {
        isClickInside = true;
      }
    });

    // If the click is outside of all .points, remove the .focalpoint-active class
    if (!isClickInside) {
      document.querySelectorAll('.focalpoint.focalpoint-active').forEach(item => {
        item.classList.remove('focalpoint-active');
      });
    }
  });
});



(function() {

  

const filted_upload_check =  document.querySelectorAll('[data-filed-upload]') || null;
    if(filted_upload_check){
      filted_upload_check.forEach(item => {
            item.addEventListener('change', (e) => {
              console.log(e);
              const file = e.target.files[0];
              // var extension = files[0].type;
              console.log(file);
              file_upload_PHP(file,e.target);
           });
        });
    }  
})();


function file_upload_PHP(file,input) {



//    const formdata = new FormData();
// formdata.append("files1", fileInput.files[0], "Produktaufbau_NatureFlex_HD_100.jpg");

// const requestOptions = {
//   method: "POST",
//   body: formdata,
//   redirect: "follow"
// };

// fetch("https://www.backup.volierenbau.de/volierenbau-upload-images-dd/file.php", requestOptions)
//   .then((response) => response.text())
//   .then((result) => console.log(result))
//   .catch((error) => console.error(error));


  


  

  const input_set = document.querySelector(`${input.getAttribute("data-fild_id")}`);
  const time_stamp = new Date().getTime();
  console.log(file,input,input_set);

  if(!input_set) return;
  
const formdata = new FormData();
// formdata.append("files1", file);
formdata.append("files1", file );
console.log(formdata);
const requestOptions = {
  method: "POST",
  body: formdata,
  redirect: "follow"
};
console.log(requestOptions);
fetch("https://www.backup.volierenbau.de/volierenbau-upload-images-dd/file.php", requestOptions)
  .then((response) => response.json())
  .then((result) => {
          console.log(result.uploadedFiles[0]);
    input_set.value = result.uploadedFiles[0];
    
  })
  .catch((error) => console.error(error));
}

function product_modal() {
  const modal_cust = document.querySelector('product-modal') || null;
  if(modal_cust){
  const product_modal_sliderOptions = modal_cust.getAttribute('data-slider-options'),
  product_modal_slideroptionConfig =JSON.parse(product_modal_sliderOptions);

 const main_pdp_slider = document.querySelector('[data-modal-pdp-swiper]') || null
  if(main_pdp_slider){
      const main_con_pdp = main_pdp_slider.swiper || false;
       console.log(!main_con_pdp && product_modal_slideroptionConfig);
      if(!main_con_pdp && product_modal_slideroptionConfig){
         product_modal_swiper = new Swiper(main_pdp_slider, product_modal_slideroptionConfig);
      }
  }
  }
}
product_modal();




